import { DeveloperApikey } from './developer-user-apikey';
import { Member } from './member';
import { Organization } from './organization';

export class User {
  public id: number;
  public apikey: string;
  public fullname: string;
  public username: string;
  public email: string;
  public organization: Organization;
  public permissions: string[];
  public ai_agents: string[];

  public status: number;
  public avatar: string;
  public background: string;
  public jobtitle: string;
  public phone: string;
  public about: string;
  public lang: string;
  public created_at?: Date;
  public updated_at?: Date;
  public member!: Member;
  public beta: boolean;
  public days_left: number;

  public developerApikey: DeveloperApikey[];


  constructor() {
    this.permissions = [];
    this.ai_agents = [];
    this.member = new Member();
    this.organization = new Organization();
    this.avatar = '';
    this.beta = false;
    this.developerApikey = [];

  }

  static create(jsonObject: any) {

    const o = new User();
    o.id = jsonObject.id ? jsonObject.id : -1;
    o.apikey = jsonObject.apikey ? jsonObject.apikey : null;
    o.fullname = jsonObject.fullname ? jsonObject.fullname : null;
    o.username = jsonObject.username ? jsonObject.username : null;

    o.email = jsonObject.email ? jsonObject.email : null;
    o.beta = jsonObject.beta ? jsonObject.beta : false;
    o.organization = jsonObject.organization
      ? Organization.create(jsonObject.organization)
      : null;
    if (jsonObject.permissions) {
      for (const perm of jsonObject.permissions) {
        o.permissions.push(perm);
      }
    }

    if (jsonObject.ai_agents) {
      for (const agent of jsonObject.ai_agents) {
        o.ai_agents.push(agent);
      }
    } else {
      o.ai_agents = [];
    }

    if (jsonObject.developer_apikey) {
      for (const devApikey of jsonObject.developer_apikey) {
        o.developerApikey.push(DeveloperApikey.create(devApikey));
      }
    }




    o.member = jsonObject.member ? Member.create(jsonObject.member) : null;

    o.phone = jsonObject.phone ? jsonObject.phone : null;
    o.about = jsonObject.about ? jsonObject.about : null;
    o.beta = jsonObject.beta ? jsonObject.beta : false;
    o.status = jsonObject.status ? jsonObject.status : -1;
    o.avatar = jsonObject.avatar ? jsonObject.avatar : null;
    o.background = jsonObject.background ? jsonObject.background : null;
    o.jobtitle = jsonObject.jobtitle ? jsonObject.jobtitle : null;
    o.lang = jsonObject.lang ? jsonObject.lang : null;

    o.created_at = jsonObject.created_at ? jsonObject.created_at : null;
    o.updated_at = jsonObject.updated_at ? jsonObject.updated_at : null;

    return o;
  }

  static update(jsonObject: any, user: User) {
    const o = new User();
    o.id = jsonObject.id ? jsonObject.id : user.id;
    o.apikey = jsonObject.apikey ? jsonObject.apikey : user.apikey;
    o.fullname = jsonObject.fullname ? jsonObject.fullname : user.fullname;
    o.username = jsonObject.username ? jsonObject.username : user.username;

    o.email = jsonObject.email ? jsonObject.email : user.email;
    o.organization = jsonObject.organization
      ? Organization.create(jsonObject.organization)
      : user.organization;
    if (jsonObject.permissions) {
      for (const perm of jsonObject.permissions) {
        o.permissions.push(perm);
      }
    } else {
      o.permissions = user.permissions;
    }


    o.member = jsonObject.member ? Member.create(jsonObject.member) : null;
    o.phone = jsonObject.phone ? jsonObject.phone : user.phone;
    o.about = jsonObject.about ? jsonObject.about : user.about;
    o.status = jsonObject.status ? jsonObject.status : user.status;
    o.avatar = jsonObject.avatar ? jsonObject.avatar : user.avatar;
    o.background = jsonObject.background ? jsonObject.background : user.background;
    o.jobtitle = jsonObject.jobtitle ? jsonObject.jobtitle : user.jobtitle;

    o.lang = jsonObject.lang ? jsonObject.lang : user.lang;

    o.created_at = jsonObject.created_at ? jsonObject.created_at : user.created_at;
    o.updated_at = jsonObject.updated_at ? jsonObject.updated_at : user.updated_at;

    o.member = jsonObject.member ? Member.create(jsonObject.member) : null;
    o.beta = jsonObject.beta ? jsonObject.beta : false;

    return o;
  }

  is2ShapesAdmin() {
    let isn = false;
    this.permissions.map(e => {
      if (e === 'ROLE_ADMIN') {
        isn = true;
      }
    });
    return isn;
  }
  is2ShapesStaff() {
    let isn = false;

    this.permissions.map(e => {
      if (e === 'ROLE_STAFF') {
        isn = true;
      }
    });
    return isn;
  }


  isOrphan() {


    return (this.member == null);

  }
  isOwner() {

    return this.member?.permissions?.includes('ROLE_OWNER');

  }
  isSupervisor() {
    return this.member?.permissions?.includes('ROLE_OWNER') || this.member?.permissions?.includes('ROLE_SUPERVISOR');

  }

  hasAccessToBoutique() {
    var res = this.member?.permissions?.includes('ROLE_OWNER') || this.member?.permissions?.includes('ROLE_SUPERVISOR') || this.member?.permissions?.includes('ROLE_BOUTIQUE');
    return res;
  }
  hasAccessToDashboard() {
    return this.member?.permissions?.includes('ROLE_OWNER') || this.member?.permissions?.includes('ROLE_DASHBOARD') || this.member?.permissions?.includes('ROLE_SUPERVISOR');
  }

  hasAccessToCanvas() {
    return this.member?.permissions?.includes('ROLE_OWNER') || this.member?.permissions?.includes('ROLE_SUPERVISOR') || this.member?.permissions?.includes('ROLE_CANVAS');
  }

  hasAccessToAi() {
    return this.member?.permissions?.includes('ROLE_OWNER') || this.member?.permissions?.includes('ROLE_AI_AGENT') || this.member?.permissions?.includes('ROLE_SUPERVISOR');
  }
}